import { useTranslation } from "react-i18next";

import { ProgressSpinner } from "../../../../../src/components/ProgressSpinner";

const PageLoadingSpinner = () => {
  const { t } = useTranslation();

  return (
    <div
      className="page-loading-spinner"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={t("loadingStates.loading")}
    >
      <ProgressSpinner size="small" aria-hidden />
    </div>
  );
};

export default PageLoadingSpinner;
